import React, {useEffect, useState} from 'react';
import AddUser from './add';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    TableRow,
    Paper,
    LinearProgress
} from '@material-ui/core';
import {connect, useSelector, useStore} from 'react-redux';
import * as auth from "../../store/ducks/auth.duck";
import {withRouter} from "react-router-dom";
import {injectIntl} from "react-intl";
import DeleteButton from '../../utils/delete';
import {coreStyle, EnhancedTableHead} from "../../styles/config";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import Translate from "../../utils/utils";

const headCells = [
    {id: 'Name', label: <Translate id="TABLE.NAME"/>},
    {id: 'Role', label: <Translate id="TABLE.ROLE"/>},
    {id: 'Country', label: <Translate id="TABLE.COUNTRY"/>},
    {id: 'Email', label: <Translate id="TABLE.ACTIONS.EMAIL"/>},
    {id: 'Created Date', label: <Translate id="TABLE.DATE"/>},
    {id: 'Actions', label: <Translate id="TABLE.ACTIONS"/>},
];

const User = (props) => {
    const {history} = props;
    const {location: {search}} = props;
    const queryParams = parseQueryParams(search);
    const perPage = queryParams.perPage;
    ;
    const [page, setPage] = React.useState(queryParams.page);
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [countries, setCountries] = useState([]);
    const initialValues = {first_name: "", last_name: "", email: "", country_id: "", role: {}, role_id: null};
    const [user, setUser] = useState(initialValues);
    const [name, setName] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(true);
    const resource = new Resource('user');
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const store = useStore();
    const currentUser = useSelector(store => store.auth.user);

    const removeItemInListing = (id) => {
        const remaining = users.filter((user) => user.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setUsers(remaining);
    };

    useEffect(() => {
        const countryResource = new Resource('country');
        const rolesResource = new Resource('role');
        countryResource.index({perPage: 350})
            .then(response => {
                const {data: {data: {data}}} = response;
                setCountries(data);
            }).catch(err => {

        });

        rolesResource.index()
            .then(response => {
                const {data: {data: {data}}} = response;
                setRoles(data);
            }).catch(err => {

        });

    }, []);

    useEffect(() => {
        const list = () => {
            const resource = new Resource('user');
            setIsLoading(true);
            resource.index({perPage, page, name: name})
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setUsers(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        }
        list();

    }, [perPage, page]);


    const handleChangePage = (e, page) => {
        setPage(++page)
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handleChangePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const handleCreate = (user) => {
        const userList = [user, ...users];
        setUsers(userList);
    };

    const handleUpdate = (user) => {
        const userList = users.map(record => {
            if (record.id === user.id) {
                return user;
            }
            return record;
        });
        setUsers(userList);

        if (user.id === currentUser.id && currentUser.role.id !== user.role_id) {

            const role_name = getRole(user);
            user.role = {id: user.role_id, name: role_name};
            user.type = role_name;
            store.dispatch({type: "UpdateUser", payload: user});
            history.push('/');
        }
    };


    const getCountry = (user) => {

        if (user.country_id !== user.country.id) {
            const country = countries.filter((country) => country.id === user.country_id);
            if (country.length > 0) {
                return country[0].name;
            }

            return 'Not Found';

        }

        return user.country.name;

    };

    const getRole = (user) => {

        const role = roles.filter((role) => role.id === user.role_id);

        if (role.length > 0) {
            return role[0].name;
        }

        return user.role.name;

    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <AddUser handleCreate={handleCreate} resource={resource} initialValues={user} key={user.id}
                         roles={roles}
                         handleUpdate={handleUpdate} onCloseModal={() => setUser(initialValues)}
                         countries={countries}/>
            </div>
            <Search onType={onType} onSubmit={onSearch} module={"User"} onClear={onClearSearch} disabled={isLoading}
                    value={queryParams.name}/>

            {isLoading && <LinearProgress color="secondary"/>}

            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            headCells={headCells}
                            rowCount={users.length}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {users.map((user) => {
                                user.getFullName = () => {
                                    return `${user.first_name} ${user.last_name}`
                                };
                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={user.id}
                                    >
                                        <TableCell component="th" scope="row">
                                            {user.getFullName()}
                                        </TableCell>
                                        <TableCell>{getRole(user)}</TableCell>
                                        <TableCell>{getCountry(user)}</TableCell>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>{user.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete' onClick={() => {
                                                setUser(user)
                                            }}>
                                                <Translate id="TABLE.ACTIONS.EDIT"/>
                                            </button>

                                            {currentUser.id !== user.id && currentUser.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={`user`}
                                                    itemId={user.id}
                                                    itemName={user.getFullName()}
                                                    removeItemInListing={removeItemInListing}
                                                />
                                            </>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handleChangePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
};

export default injectIntl(withRouter(connect(null, auth.actions)(User)));
